import React, { useState, useMemo } from 'react';
import useSharedDataContext from '~/contexts/shared-data';
import sfApiFetch from '~/models/sfapi';
import cmsFetch from '~/helpers/cms-fetch';
import debounce from 'lodash/debounce';
export const schoolTypeValues = [
    'College/University (4)',
    'Technical/Community College (2)',
    'Career School/For-Profit (2)',
    'High School',
    'K-12 School',
    'Home School',
    'Other'
];
const debouncedFetch = debounce((schoolFetch, value, setSchools) => {
    if ((value === null || value === void 0 ? void 0 : value.length) > 1) {
        schoolFetch(value)
            .then((list) => list === null || list === void 0 ? void 0 : list.map((entry) => ({
            name: entry.name,
            type: entry.school_type || entry.type, // different names in sfapi and old cms?
            location: entry.location,
            total_school_enrollment: entry.total_school_enrollment // eslint-disable-line camelcase
        })))
            .then(setSchools);
    }
    else {
        setSchools([]);
    }
}, 300);
function useSchoolFetchFunction() {
    const { flags } = useSharedDataContext();
    const { my_openstax: isEnabled } = flags || {};
    const fn = useMemo(() => (isEnabled
        ? (value) => sfApiFetch('schools', `/search?name=${value}`)
        : (value) => cmsFetch(`salesforce/schools?search=${value}`)), [isEnabled]);
    return fn;
}
export default function useMatchingSchools(value) {
    const schoolFetch = useSchoolFetchFunction();
    const [schools, setSchools] = useState([]);
    const schoolNames = useMemo(() => { var _a; return (_a = schools === null || schools === void 0 ? void 0 : schools.map((s) => s.name).sort()) !== null && _a !== void 0 ? _a : []; }, [schools]);
    const schoolSet = useMemo(() => new window.Set(schoolNames.map((s) => s.toLowerCase())), [schoolNames]);
    const schoolIsOk = schoolSet.has(value.toLowerCase());
    const selectedSchool = schoolIsOk &&
        (schools === null || schools === void 0 ? void 0 : schools.find((s) => s.name.toLowerCase() === value.toLowerCase()));
    const schoolOptions = useMemo(() => schoolNames.map((n) => ({ label: n, value: n })), [schoolNames]);
    React.useEffect(() => debouncedFetch(schoolFetch, value, setSchools), [value, schoolFetch]);
    return { schoolNames, schoolIsOk, selectedSchool, schoolOptions };
}
